<div class="master-product-carousel section static-carousel"
    [ngClass]="{'master-product-carousel--discovery': urlPageName === 'dealsdiscovery-carousel'}">
    <div class="slick-product-carousel clearfix preset-block-height" data-qa="prd-crsl">
        <div class="carousel-header-wrapper">
            <div class="carousel-header-text-wrapper">
                <h2 class="carousel-header-text m0"
                    [ngClass]="{'carousel-header-text--discovery': urlPageName === 'dealsdiscovery-carousel'}"
                    data-qa="prd-crsl-hdng-bstsllrs-n-yr-r"> {{carouselData?.Title}}</h2>
            </div>
        </div>
        <lazy-wrapper 
            data-lazy-component="product-carousel" 
            data-carousel-type="apidriven"
            data-carousel-title="{{carouselData?.Title}}" 
            [attr.data-carousel-users]="carouselUsers"
            data-carousel-driven="featured-products"
            data-is-dynamic-grid-flow="true"
            [attr.data-carousel-api]="sponsoredCarouselAPIPath" 
            data-carousel-api-post="1_" 
            data-navigation-type="page-by-page" 
            data-seller-type="abs" 
            data-carousel-pdp="false" 
            [attr.data-page-name]="pageName"
            data-disable-lazy-load="true">
        </lazy-wrapper>
    </div>
</div>
